<template>
    <ModalTheme :with-content="true" @close="closeModal" :theme="true" :fix-height="false">
        <template slot="main">
            <div class="wrapper">
                <div>
                    <div class="headline bold">Add item to forecast</div>
                    <div class="top"><CatalogueItemDescription :item="convertedItem" /></div>

                    <div class="middle">
                        <div>
                            <div>Select forecast</div>
                            <ItemManager
                                :item="convertedItem"
                                :do-save="doSave"
                                @saved="
                                    doSave = false;
                                    closeModal();
                                "
                            />
                        </div>
                    </div>
                </div>
                <div class="end">
                    <div><ClientColorButton @click="doSave = true;">Save</ClientColorButton></div>
                </div>
            </div>
        </template>
    </ModalTheme>
</template>

<script>
import ModalTheme from "@/components/ui/ModalTheme";
import { mapGetters } from "vuex";
import ItemManager from "@/components/forecasts/elements/catalogue/CatalogueItemManager";
import { convertItem } from "@/components/forecasts/model/item";
import CatalogueItemDescription from "@/components/forecasts/elements/catalogue/CatalogueItemDescription";

export default {
    components: { CatalogueItemDescription, ItemManager, ModalTheme },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            doSave: false
        };
    },
    computed: {
        ...mapGetters("forecast", { forecasts: "updatable" }),
        convertedItem() {
            return convertItem(this.item);
        }
    },
    methods: {
        closeModal() {
            this.$emit("close");
        }
    }
};
</script>
<style scoped lang="scss">
.wrapper {
    text-transform: uppercase;
    font-size: 2em;
    .headline {
        margin-bottom: 20px;
    }
    .top {
        display: flex;
        .description {
            font-size: 0.8em;
        }
    }
    .middle {
        display: flex;
        div {
            margin-left: auto;
            margin-right: auto;
            padding: 5px 0;
        }
    }
    .end {
        display: flex;
        div {
            margin-left: auto;
        }
    }
}
.texts {
    margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// Modal.vue?0e922d77